import React, { Component } from 'react';
import { Toast, Icon, TextareaItem, Button } from 'antd-mobile';
import * as services from '../../projects/services';
import { createBrowserHistory } from "history";
import './style.less';
const history = createBrowserHistory();
export class Refund extends Component {
    constructor(props) {
        super(props);
        this.state = {
            detailId: this.props.detailid,
            rdata: [],
            detail: '',
            sum: 0,
            remark: '',
            maxsum: 0,
        }
        this.textChange = this.textChange.bind(this);
        this.ApplyOrderRefund = this.ApplyOrderRefund.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        const detailId = this.props.detailid;
        //获取退款信息
        services.GetOrderRefundList(detailId, '').then(data => {
            if (data.status === 0) {
                this.setState({ rdata: data.result, detail: data.result.detail, maxsum: data.result.count, sum: data.result.count });
            } else {
                Toast.offline(data.message);
            }
        })

    }
    onClose = () => { // 学习挣钱，调用父组件方法
        this.props.onClose('modal3');
    }
    textChange = (e) => {
        this.setState({
            remark: e
        });
    }
    handleChange = (event) => {
        if (parseInt(event.target.value) >= parseInt(this.state.maxsum)) {
            document.getElementById("refsum").value = this.state.maxsum;
            Toast.offline('最多只能退' + this.state.maxsum + '个套餐');
        } else if (parseInt(event.target.value) <= 0) {
            document.getElementById("refsum").value = 1;
            Toast.offline('请输入 0 以上的数字');
        } else {
            this.setState({
                sum: event.target.value
            });
        }
    }
    //申请退款
    ApplyOrderRefund = () => {
        if (this.state.remark === '' || this.state.remark === null) {
            Toast.offline('退款说明不能为空', 2);
            return false;
        }
        let parameter = { detailId: this.state.detailId, sum: this.state.sum, remark: this.state.remark };
        services.ApplyOrderRefund(parameter, '').then(data => {
            if (data.status === 0) {
                Toast.success('申请成功', 2, () => {
                    this.props.onClose('modal3');
                    history.push('/members/orderment/3');
                    history.go();
                    //this.props.GetOrderListpage();
                });
            } else {
                Toast.offline(data.message);
            }
        })

    }
    onMinus = () => {
        let num = this.state.sum;
        if (num === 0) {
            Toast.info('已经是最低了', 2);
        } else {
            document.getElementById("refsum").value = parseInt(num) - 1;
            this.setState({ sum: parseInt(num) - 1 });
        }

    }
    onPlus = () => {
        let num = this.state.sum;
        if (num === this.state.maxsum) {
            Toast.info('您本次最多退' + this.state.maxsum + '个套餐', 2);
        } else {
            document.getElementById("refsum").value = parseInt(num) + 1;
            this.setState({ sum: parseInt(num) + 1 });

        }
    }
    render() {
        const { detail } = this.state;
        return (<div className="order">

            {
                !!detail ? <div>
                    <div className="title">订单号：<span className="fy">{this.state.detailId}</span></div>
                    <table className="ordertable">
                        <tbody>
                            <tr>
                                <th>套餐名称</th>
                                <th>价格（元）</th>
                                <th>数量（张）</th>
                                <th>总价（元）</th>
                            </tr>
                            <tr>
                                <td>{detail.title}</td>
                                <td>{detail.price}</td>
                                <td>{detail.buycount}</td>
                                <td>{detail.buymoney}</td>
                            </tr>
                        </tbody></table>
                    <div className="operatediv">
                        <div className="name">退款数量：</div>
                        <div className="operate" >
                            <span className="mico" onClick={this.onMinus} ><Icon type="minus" style={{ fontSize: '10px', }} /></span>
                            <input type="text" id="refsum" className="num" defaultValue={this.state.sum} onChange={this.handleChange} />
                            <span className="mico" onClick={this.onPlus} ><Icon type="plus" style={{ fontSize: '10px' }} /></span>
                        </div>
                    </div>
                    <div className="tips">您本次最多退（{this.state.maxsum}）个体检套餐</div>

                    <TextareaItem className="textarea"
                        placeholder="可输入多行文本，不超过256个字"
                        title="退款说明"
                        rows={3}
                        onChange={this.textChange}
                    />
                    <div className="footBut">
                        <Button onClick={this.onClose}  >取消</Button><Button className="am-button2" onClick={this.ApplyOrderRefund} >确定</Button>
                    </div>
                </div> : ''
            }
        </div>);
    }

}